import type { IconNode } from '../types';

/**
 * @name coat-hanger
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOSA1YTMgMyAwIDEgMSA1LjEgMi4xbC0xLjUgMS41QTIgMiAwIDAgMCAxMiAxMHYxIiAvPgogIDxwYXRoIGQ9Ik00IDIxYTIgMiAwIDAgMS0xLjEtMy43TDEyIDExbDkuMiA2LjRBMiAyIDAgMCAxIDIwIDIxWiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/coat-hanger
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const coatHanger: IconNode = [
  ['path', { d: 'M9 5a3 3 0 1 1 5.1 2.1l-1.5 1.5A2 2 0 0 0 12 10v1', key: '1dhcsm' }],
  ['path', { d: 'M4 21a2 2 0 0 1-1.1-3.7L12 11l9.2 6.4A2 2 0 0 1 20 21Z', key: '6t9fxx' }],
];

export default coatHanger;
